import {
  Channel,
  Channel as ReturnChannel,
} from "@redotech/congo-enums/channel";
import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  channelFromModel,
  validateChannelCondition,
  type ChannelState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { assertNever } from "@redotech/util/type";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CHANNEL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ChannelState>>,
): ConditionType<ChannelState, Condition.Channel> => ({
  name: CONDITION_NAMES[Condition.CHANNEL],
  description(state) {
    if (!state) {
      return t(
        "The channel where the return is submitted. Sales channel is the original order's channel.",
      );
    }
    switch (state) {
      case ReturnChannel.Pointofsale:
        return t("Return channel: Point of Sale");
      case ReturnChannel.Web:
        return t("Return channel: Web");
      case ReturnChannel.Shopapp:
        return t("Return channel: Shop App");
      case ReturnChannel.Ai:
        return t("Return channel: AI");
      case ReturnChannel.Api:
        return t("Return channel: API");
      default:
        assertNever(state);
    }
  },
  Details(props: ConditionTypeDetailsProps<ChannelState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel(model: Condition.Channel) {
    return channelFromModel(model);
  },
  toModel(state) {
    return { type: Condition.CHANNEL, channel: state ?? Channel.Web };
  },
  valid(state) {
    return validateChannelCondition(state).valid;
  },
});
